class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;
		this.body = document.querySelector('body');

		this.megaMenuItems = Array.from(el.querySelectorAll('.mega-menu-item'));
		this.mobileLinks = el.querySelectorAll('.mobile-top-level-link-clickable');
		this.megaMenuBg = document.querySelector('.site-header__megamenu-bg');

		this.openDelayMs = 120;
		this.closeDelayMs = 400;
		this.openTimer = null;
		this.closeTimer = null;
		this.suppressFocusOpen = false;
		this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
				});
			});
		}

		window.addEventListener('resize', () => this.updateHeaderHeightVar());
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());

		this.megaMenuItems.forEach((item) => {
			const toggle = item.querySelector('.mega-menu-toggle');

			if (!toggle) {
				return;
			}

			toggle.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.clearTimers();

				if (item.classList.contains('active')) {
					this.closeMenu(item);
				} else {
					this.openMenu(item);
				}
			});

			item.addEventListener('focusin', () => {
				if (!this.canHover.matches || this.suppressFocusOpen) {
					return;
				}

				this.clearTimers();
				this.openMenu(item);
			});

			item.addEventListener('focusout', (e) => {
				if (item.contains(e.relatedTarget)) {
					return;
				}

				this.closeMenu(item, { returnFocus: false });
			});

			item.addEventListener('mouseenter', () => {
				if (!this.canHover.matches) {
					return;
				}

				this.clearCloseTimer();
				this.openTimer = window.setTimeout(() => {
					this.openMenu(item);
				}, this.openDelayMs);
			});

			item.addEventListener('mouseleave', () => {
				if (!this.canHover.matches) {
					return;
				}

				this.clearOpenTimer();
				this.closeTimer = window.setTimeout(() => {
					this.closeMenu(item, { returnFocus: false });
				}, this.closeDelayMs);
			});
		});

		if (this.megaMenuBg) {
			this.megaMenuBg.addEventListener('click', () => {
				this.closeAllMenus();
			});
		}

		document.addEventListener('keydown', (evt) => {
			if (evt.key !== 'Escape') {
				return;
			}

			const activeItem = this.getActiveMenuItem();

			if (!activeItem) {
				return;
			}

			this.closeMenu(activeItem, { returnFocus: true });
		});
	}

	getActiveMenuItem() {
		return this.megaMenuItems.find((item) => item.classList.contains('active')) || null;
	}

	getToggle(item) {
		return item.querySelector('.mega-menu-toggle');
	}

	clearOpenTimer() {
		if (this.openTimer) {
			window.clearTimeout(this.openTimer);
			this.openTimer = null;
		}
	}

	clearCloseTimer() {
		if (this.closeTimer) {
			window.clearTimeout(this.closeTimer);
			this.closeTimer = null;
		}
	}

	clearTimers() {
		this.clearOpenTimer();
		this.clearCloseTimer();
	}

	openMenu(item) {
		this.clearTimers();

		this.megaMenuItems.forEach((otherItem) => {
			if (otherItem !== item) {
				this.setMenuOpenState(otherItem, false);
			}
		});

		this.setMenuOpenState(item, true);
		this.body.classList.add('no-scroll');

		if (this.megaMenuBg) {
			this.megaMenuBg.classList.add('active');
		}
	}

	closeMenu(item, { returnFocus = false } = {}) {
		this.clearTimers();
		this.setMenuOpenState(item, false);

		const stillOpen = this.getActiveMenuItem();

		if (!stillOpen) {
			this.body.classList.remove('no-scroll');

			if (this.megaMenuBg) {
				this.megaMenuBg.classList.remove('active');
			}
		}

		if (returnFocus) {
			const toggle = this.getToggle(item);

			if (toggle) {
				this.suppressFocusOpen = true;
				toggle.focus();
				window.requestAnimationFrame(() => {
					this.suppressFocusOpen = false;
				});
			}
		}
	}

	closeAllMenus({ returnFocus = false } = {}) {
		const activeItem = this.getActiveMenuItem();

		this.megaMenuItems.forEach((item) => {
			this.setMenuOpenState(item, false);
		});

		this.clearTimers();
		this.body.classList.remove('no-scroll');

		if (this.megaMenuBg) {
			this.megaMenuBg.classList.remove('active');
		}

		if (returnFocus && activeItem) {
			const toggle = this.getToggle(activeItem);

			if (toggle) {
				this.suppressFocusOpen = true;
				toggle.focus();
				window.requestAnimationFrame(() => {
					this.suppressFocusOpen = false;
				});
			}
		}
	}

	setMenuOpenState(item, isOpen) {
		const toggle = this.getToggle(item);

		item.classList.toggle('active', isOpen);

		if (toggle) {
			toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		}
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	removeSearchValue() {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
